import React from "react";

export const PAGE_MIST_OVERLAY_CSS = `
	@keyframes er-page-mist-overlay-clear {
		0% { opacity: 0.88; }
		18% { opacity: 0.76; }
		42% { opacity: 0.48; }
		68% { opacity: 0.18; }
		88% { opacity: 0.04; }
		100% { opacity: 0; visibility: hidden; }
	}
	@keyframes er-page-mist-drift-a {
		0% { transform: translate(-4%, 6%) scale(1.05); opacity: 0.7; }
		100% { transform: translate(6%, -8%) scale(1.12); opacity: 0; }
	}
	@keyframes er-page-mist-drift-b {
		0% { transform: translate(5%, -4%) scale(1.03); opacity: 0.65; }
		100% { transform: translate(-7%, 5%) scale(1.1); opacity: 0; }
	}
	.er-page-mist-overlay {
		position: absolute;
		inset: 0;
		z-index: 840;
		pointer-events: none;
		border-radius: inherit;
		overflow: hidden;
		animation: er-page-mist-overlay-clear var(--er-mist-dur, 0.55s) cubic-bezier(0.22, 1, 0.36, 1) forwards;
	}
	.er-page-mist-overlay__base {
		position: absolute;
		inset: 0;
		background:
			radial-gradient(ellipse 115% 75% at 50% 105%, rgba(148, 163, 184, 0.62), transparent 58%),
			radial-gradient(ellipse 85% 55% at 18% 35%, rgba(186, 198, 212, 0.48), transparent 52%),
			radial-gradient(ellipse 75% 50% at 82% 42%, rgba(203, 213, 225, 0.44), transparent 50%),
			linear-gradient(180deg, rgba(100, 116, 139, 0.22) 0%, rgba(226, 232, 240, 0.18) 100%);
	}
	.er-page-mist-overlay__wisp {
		position: absolute;
		inset: -25%;
		filter: blur(22px);
		pointer-events: none;
	}
	.er-page-mist-overlay__wisp--a {
		background: radial-gradient(ellipse 50% 42% at 35% 58%, rgba(241, 245, 249, 0.55), transparent 68%);
		animation: er-page-mist-drift-a calc(var(--er-mist-dur, 0.55s) * 1.1) ease-out forwards;
	}
	.er-page-mist-overlay__wisp--b {
		background: radial-gradient(ellipse 48% 40% at 68% 38%, rgba(226, 232, 240, 0.5), transparent 65%);
		animation: er-page-mist-drift-b var(--er-mist-dur, 0.55s) ease-out forwards;
	}
`;

export default function EscapeRoomPageMistOverlay({ durationMs = 550, overlayKey }) {
	const sec = Math.max(0.35, (Number(durationMs) || 550) / 1000);
	return (
		<>
			<style>{PAGE_MIST_OVERLAY_CSS}</style>
			<div
				key={overlayKey || "mist"}
				className="er-page-mist-overlay"
				style={{ "--er-mist-dur": `${sec}s` }}
				aria-hidden
			>
				<div className="er-page-mist-overlay__base" />
				<div className="er-page-mist-overlay__wisp er-page-mist-overlay__wisp--a" />
				<div className="er-page-mist-overlay__wisp er-page-mist-overlay__wisp--b" />
			</div>
		</>
	);
}
